import { ReactNode, useEffect, useState } from 'react';
import { format, parse, isValid, formatISO } from 'date-fns'
import { enNZ } from 'date-fns/locale';
import ReactInputMask from 'react-input-mask';
import TextInputBase from './TextInputBase'
import { useContextField } from '../../../api';
import { ErrorMessage, FormLabel } from '../helpers';

export default (props: {
    label: string;
    name: string;
    disabled?: boolean;
    endAdornment?: ReactNode;
}) => {
    const { name, label, endAdornment, disabled } = props;
    const [field, _, helper] = useContextField(name);
    const [value, setValue] = useState<string>(field.value ? format(new Date(field.value), 'P', { locale: enNZ }) : '');
    const placeholder = 'dd/mm/yyyy';

    useEffect(() => {
        setValue(field.value ? format(new Date(field.value), 'P', { locale: enNZ }) : '');
    }, [field.value]);

    return <>
        <FormLabel label={label} />
        <ReactInputMask
            mask="99/99/9999"
            maskPlaceholder={placeholder}
            name={name}
            value={value}
            disabled={disabled}
            onChange={e => {
                const _value = e.target.value;
                setValue(_value);
                _value !== placeholder && helper.setTouched(false); // Work around for blur causing validation issue.
            }}
            onBlur={_ => {
                const _value = value === placeholder ? '' : value;
                setValue(_value);
                if (_value && _value !== placeholder) {
                    const parsedDate = parse(_value, 'P', new Date(), { locale: enNZ });
                    if (isValid(parsedDate)) {
                        helper.setValue(formatISO(parsedDate, { representation: 'date' }));
                        helper.setTouched(true);
                    }
                    else helper.setValue(undefined);
                } else {
                    helper.setValue(undefined);
                }
            }}
        >
            <TextInputBase inputMode="numeric" endAdornment={endAdornment} variant="outlined" />
        </ReactInputMask>
        <ErrorMessage name={name} />
    </>
}
